import { action, computed, extendObservable, observable } from 'mobx';
import { cadastreProps } from '../cadastreFields';

export class SaleEditStore {
  @observable page = 1;
  @observable offerData = {};
  @observable docs = [];

  @computed get isPage1Valid() {
    const { object_type } = this.offerData;
    return !!object_type;
  }

  @computed get isPage2Valid() {
    return true;
  }

  @computed get isPage3Valid() {
    return true;
  }

  @action initialize(offerData, docs) {
    this.offerData = Object.assign({}, offerData);
    this.docs = (docs || []).slice();
    extendObservable(this.offerData, {
      // Page1
      object_type: offerData.object_type || '',
      object_address_street: offerData.object_address_street || '',
      object_address_house_number: offerData.object_address_house_number || '',
      object_address_apartment_number:
        offerData.object_address_apartment_number || '',
      object_address_state: offerData.object_address_state || '',
      object_address_zip: offerData.object_address_zip || '',

      cadastre: offerData.cadastre || observable([{ ...cadastreProps() }]),

      cadastre_registry_number: offerData.cadastre_registry_number || '',
      cadastre_city: offerData.cadastre_city || '',
      cadastre_volume: offerData.cadastre_volume || '',
      cadastre_book: offerData.cadastre_book || '',
      cadastre_folio: offerData.cadastre_folio || '',
      cadastre_property_number: offerData.cadastre_property_number || '',

      seller_notes: offerData.seller_notes || '',
      debt_type: offerData.debt_type || '',
      debt_amount: offerData.debt_amount || '',
      debt_details: offerData.debt_details || '',

      // Page2
      seller_type: offerData.seller_type || 'private',
      seller_company_name: offerData.seller_company_name || '',
      seller_vat_id: offerData.seller_company_vat_id || '',
      seller_salutation: offerData.seller_salutation || '',
      seller_firstName: offerData.seller_firstName || '',
      seller_lastName: offerData.seller_lastName || '',
      seller_street: offerData.seller_street || '',
      seller_house_number: offerData.seller_house_number || '',
      seller_street_additional: offerData.seller_street_additional || '',
      seller_zip: offerData.seller_zip || '',
      seller_city: offerData.seller_city || '',
      seller_country: offerData.seller_country || 'España',
      seller_country_code: offerData.seller_country_code || 'ES',

      seller_id_type: offerData.seller_id_type || '',
      seller_id_number: offerData.seller_id_number || '',
      seller_citizenship: offerData.seller_citizenship || 'España',
      seller_citizenship_code: offerData.seller_citizenship_code || 'ES',

      additional_sellers: offerData.additional_sellers || [],
      deposit_type: offerData.deposit_type || 'none',
      deposit_fixed_amount: offerData.deposit_fixed_amount || 0,
      deposit_percentage: offerData.deposit_percentage || 0,
      security_type: offerData.security_type || 'none',
      security_fixed_amount: offerData.security_fixed_amount || 0,
      security_percentage: offerData.security_percentage || 0,

      closing_seller_deadline_days: offerData.closing_seller_deadline_days || 0,
      closing_seller_target_days: offerData.closing_seller_target_days || 0,

      notary: offerData.notary || '',
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/@propnow/containers/Sale/SaleEditSection/_es/stores/index.js